export default __webpack_public_path__ + "static/media/boyu.06b0f954.JPG";